<ng-container *transloco="let t">
<ng-template #manufacturedHomeDetails>
	<form #manufacturedHomeDetailsForm="ngForm" novalidate id="manufacturedHomeDetailsForm"
		name="manufacturedHomeDetailsForm">
		<div class="row g-9 mb-8">
			@if (!isHidden('subjectProperty.landType')) {
				<div class="col-md-3 fv-row">
					<label class="form-label"
						[ngClass]="{'required': isRequired('subjectProperty.landType')}">{{getLabel('subjectProperty.landType',
						t('wizard.manufacturedHome.landType'))}}</label>
					<select class="form-select form-select-solid" data-control="select2" name="landType" #landType="ngModel"
						[(ngModel)]="mortgage.subjectProperty.landType"
						[ngClass]="{'is-invalid' : landType && landType.touched && landType.invalid}"
						[required]="isRequired('subjectProperty.landType')">
						<option [ngValue]="null">{{ t('common.selectOne') }}</option>
						@for (landType of landTypes; track landType.value) {
							<option [ngValue]="landType.value">{{landType.name}}</option>
						}
					</select>
					<div class="invalid-feedback">{{ t('wizard.manufacturedHome.pleaseSelectLandType') }}</div>
				</div>
			}
			@if (!isHidden('subjectProperty.sizeOfLand')) {
				<div class="col-md-3 fv-row">
					<label class="form-label"
						[ngClass]="{'required': isRequired('subjectProperty.sizeOfLand')}">{{getLabel('subjectProperty.sizeOfLand',
						t('wizard.manufacturedHome.sizeOfLand'))}}</label>
					<select class="form-select form-select-solid" data-control="select2" name="sizeOfLand" #sizeOfLand="ngModel"
						[(ngModel)]="mortgage.subjectProperty.sizeOfLand"
						[ngClass]="{'is-invalid' : sizeOfLand && sizeOfLand.touched && sizeOfLand.invalid}"
						[required]="isRequired('subjectProperty.sizeOfLand')">
						<option [ngValue]="null">{{ t('common.selectOne') }}</option>
						@for (sizeOfLand of sizeOfLandTypes; track sizeOfLand.value) {
							<option [ngValue]="sizeOfLand.value">{{sizeOfLand.name}}</option>
						}
					</select>
					<div class="invalid-feedback">{{ t('wizard.manufacturedHome.pleaseSelectSizeOfLand') }}</div>
				</div>
			}
			@if (!isHidden('subjectProperty.estimatedLandValue')) {
				<div class="col-md-3 fv-row">
					<label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
						<span
							[ngClass]="{'required': isRequired('subjectProperty.estimatedLandValue')}">{{getLabel('subjectProperty.estimatedLandValue',
							t('wizard.manufacturedHome.estimatedLandValue'))}}
						</span>
					</label>
					<div class="position-relative">
						<input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal"
							prefix="$"
							[ngClass]="{'is-invalid' : estimatedLandValue && estimatedLandValue.touched && estimatedLandValue.invalid}"
							#estimatedLandValue="ngModel" [required]="isRequired('subjectProperty.estimatedLandValue')"
							[(ngModel)]="mortgage.subjectProperty.estimatedLandValue" placeholder="" name="estimatedLandValue" />
						<div class="invalid-feedback">{{ t('wizard.manufacturedHome.pleaseEnterEstimatedLandValue') }}</div>
					</div>
				</div>
			}
			@if (!isHidden('subjectProperty.amountOwned')) {
				<div class="col-md-3 fv-row">
					<label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
						<span
							[ngClass]="{'required': isRequired('subjectProperty.amountOwned')}">{{getLabel('subjectProperty.amountOwned',
							t('wizard.manufacturedHome.amountOwed'))}}
						</span>
					</label>
					<div class="position-relative">
						<input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal"
							prefix="$" [ngClass]="{'is-invalid' : amountOwned && amountOwned.touched && amountOwned.invalid}"
							#amountOwned="ngModel" [required]="isRequired('subjectProperty.amountOwned')"
							[(ngModel)]="mortgage.subjectProperty.amountOwned" placeholder="" name="amountOwned" />
						<div class="invalid-feedback">{{ t('wizard.manufacturedHome.pleaseEnterAmountOwed') }}</div>
					</div>
				</div>
			}
			@if (!isHidden('subjectProperty.manufacturedHomeMake')) {
				<div class="col-md-3 fv-row">
					<label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
						<span
							[ngClass]="{'required': isRequired('subjectProperty.manufacturedHomeMake')}">{{getLabel('subjectProperty.manufacturedHomeMake',
							t('wizard.manufacturedHome.make'))}}
						</span>
					</label>
					<div class="position-relative">
						<input type="text" class="form-control form-control-solid"
							[(ngModel)]="mortgage.subjectProperty.manufacturedHomeMake"
							[required]="isRequired('subjectProperty.manufacturedHomeMake')" placeholder=""
							name="manufacturedHomeMake"
							[ngClass]="{'is-invalid' : manufacturedHomeMake && manufacturedHomeMake.touched && manufacturedHomeMake.invalid}"
							#manufacturedHomeMake="ngModel" />
						<div class="invalid-feedback">{{ t('wizard.manufacturedHome.pleaseEnterMake') }}</div>
					</div>
				</div>
			}
			@if (!isHidden('subjectProperty.manufacturedHomeModel')) {
				<div class="col-md-3 fv-row">
					<label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
						<span
							[ngClass]="{'required': isRequired('subjectProperty.manufacturedHomeModel')}">{{getLabel('subjectProperty.manufacturedHomeModel',
							t('wizard.manufacturedHome.model'))}}
						</span>
					</label>
					<div class="position-relative">
						<input type="text" class="form-control form-control-solid"
							[(ngModel)]="mortgage.subjectProperty.manufacturedHomeModel"
							[required]="isRequired('subjectProperty.manufacturedHomeModel')" placeholder=""
							name="manufacturedHomeModel"
							[ngClass]="{'is-invalid' : manufacturedHomeModel && manufacturedHomeModel.touched && manufacturedHomeModel.invalid}"
							#manufacturedHomeModel="ngModel" />
						<div class="invalid-feedback">{{ t('wizard.manufacturedHome.pleaseEnterModel') }}</div>
					</div>
				</div>
			}
			@if (!isHidden('subjectProperty.manufacturedHomeSalesPrice')) {
				<div class="col-md-3 fv-row">
					<label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
						<span
							[ngClass]="{'required': isRequired('subjectProperty.manufacturedHomeSalesPrice')}">{{getLabel('subjectProperty.manufacturedHomeSalesPrice',
							t('wizard.manufacturedHome.salesPrice'))}}
						</span>
					</label>
					<div class="position-relative">
						<input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal"
							prefix="$" [ngClass]="{'is-invalid' : salesPrice && salesPrice.touched && salesPrice.invalid}"
							#salesPrice="ngModel" [required]="isRequired('subjectProperty.manufacturedHomeSalesPrice')"
							[(ngModel)]="mortgage.subjectProperty.manufacturedHomeSalesPrice" placeholder="" name="salesPrice" />
						<div class="invalid-feedback">{{ t('wizard.manufacturedHome.pleaseEnterSalesPrice') }}</div>
					</div>
				</div>
			}
			@if (!isHidden('subjectProperty.manufacturedHomePriceOfHome')) {
				<div class="col-md-3 fv-row">
					<label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
						<span
							[ngClass]="{'required': isRequired('subjectProperty.manufacturedHomePriceOfHome')}">{{getLabel('subjectProperty.manufacturedHomePriceOfHome',
							t('wizard.manufacturedHome.priceOfHome'))}}
						</span>
					</label>
					<div class="position-relative">
						<input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal"
							prefix="$" [ngClass]="{'is-invalid' : priceOfHome && priceOfHome.touched && priceOfHome.invalid}"
							#priceOfHome="ngModel" [required]="isRequired('subjectProperty.manufacturedHomePriceOfHome')"
							[(ngModel)]="mortgage.subjectProperty.manufacturedHomePriceOfHome" placeholder="" name="priceOfHome" />
						<div class="invalid-feedback">{{ t('wizard.manufacturedHome.pleaseEnterPriceOfHome') }}</div>
					</div>
				</div>
			}
			@if (!isHidden('subjectProperty.manufacturedHomeLotOwnershipType')) {
				<div class="col-md-3 fv-row">
					<label class="form-label"
						[ngClass]="{'required': isRequired('subjectProperty.manufacturedHomeLotOwnershipType')}">{{getLabel('subjectProperty.manufacturedHomeLotOwnershipType',
						t('wizard.manufacturedHome.lotOwnershipType'))}}</label>
					<select class="form-select form-select-solid" data-control="select2" name="lotOwnershipType" #lotOwnershipType="ngModel"
						[(ngModel)]="mortgage.subjectProperty.manufacturedHomeLotOwnershipType"
						[ngClass]="{'is-invalid' : lotOwnershipType && lotOwnershipType.touched && lotOwnershipType.invalid}"
						[required]="isRequired('subjectProperty.manufacturedHomeLotOwnershipType')">
						<option [ngValue]="null">{{ t('common.selectOne') }}</option>
						@for (lotOwnershipType of lotOwnershipTypes; track lotOwnershipType.value) {
							<option [ngValue]="lotOwnershipType.value">{{lotOwnershipType.name}}</option>
						}
					</select>
					<div class="invalid-feedback">{{ t('wizard.manufacturedHome.pleaseSelectLotOwnershipType') }}</div>
				</div>
			}
			@if (mortgage.subjectProperty.manufacturedHomeLotOwnershipType === 'Rented' && !isHidden('subjectProperty.manufacturedHomeLotRentalAmount')) {
				<div class="col-md-3 fv-row">
					<label class="d-flex align-items-center fs-6 fw-bold form-label mb-2">
						<span
							[ngClass]="{'required': isRequired('subjectProperty.manufacturedHomeLotRentalAmount')}">{{getLabel('subjectProperty.manufacturedHomeLotRentalAmount',
							t('wizard.manufacturedHome.lotRentalAmount'))}}
						</span>
					</label>
					<div class="position-relative">
						<input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal"
							prefix="$" [ngClass]="{'is-invalid' : lotRentalAmount && lotRentalAmount.touched && lotRentalAmount.invalid}"
							#lotRentalAmount="ngModel" [required]="isRequired('subjectProperty.manufacturedHomeLotRentalAmount')"
							[(ngModel)]="mortgage.subjectProperty.manufacturedHomeLotRentalAmount" placeholder="" name="subjectProperty.manufacturedHomeLotRentalAmount" />
						<div class="invalid-feedback">{{ t('wizard.manufacturedHome.pleaseEnterLotRentalAmount') }}</div>
					</div>
				</div>
			}
		</div>
	</form>
</ng-template>

<wizard-step-template [stepMainTemplate]="manufacturedHomeDetails" [step]="step"
	[stepComponent]="this"></wizard-step-template>
</ng-container>
